const API_BASE = process.env.REACT_APP_API_BASE || "";

export async function sendOtp(phone, mode) {
  const response = await fetch(`${API_BASE}/api/otp/send-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone, mode }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Failed to send OTP");
  }

  return response.json();
}

export async function verifyOtp(sessionId, otp, phone) {
  const response = await fetch(`${API_BASE}/api/otp/verify-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sessionId, otp, phone }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "OTP verification failed");
  }

  return response.json();
}

export async function createPremiumOrder(idToken, profileId) {
  const response = await fetch(`${API_BASE}/api/payments/create-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ profileId }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Could not start payment.");
  }

  return response.json();
}

export async function fetchMembershipCatalog(planId) {
  const search = planId ? `?planId=${encodeURIComponent(planId)}` : "";
  const response = await fetch(`${API_BASE}/api/payments/catalog${search}`, {
    method: "GET",
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Could not load membership catalog.");
  }

  return response.json();
}

export async function validatePremiumCoupon(idToken, payload) {
  const response = await fetch(`${API_BASE}/api/payments/validate-coupon`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Coupon validation failed.");
  }

  return response.json();
}

export async function createPremiumOrderWithCoupon(idToken, payload) {
  const response = await fetch(`${API_BASE}/api/payments/create-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Could not start payment.");
  }

  return response.json();
}

export async function fetchMyPaymentHistory(idToken) {
  const response = await fetch(`${API_BASE}/api/payments/my-history`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Could not load payment history.");
  }

  return response.json();
}

export async function fetchAdminPayments(idToken) {
  const response = await fetch(`${API_BASE}/api/payments/admin/list`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Could not load payments.");
  }

  return response.json();
}

export async function verifyPremiumPayment(idToken, payload) {
  const response = await fetch(`${API_BASE}/api/payments/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Payment verification failed.");
  }

  return response.json();
}

export async function recordFailedPayment(idToken, payload) {
  try {
    await fetch(`${API_BASE}/api/payments/record-failed`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify(payload),
    });
  } catch {
    // Best-effort logging; do not block the UI on failure
  }
}

export async function recordLoginActivity(payload) {
  const response = await fetch(`${API_BASE}/api/activity/record-login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.message || "Failed to record login activity");
  }

  return response.json();
}
